export default __webpack_public_path__ + "static/media/2.c2d54354.png";